import React from 'react';
import {
  Edit,
  SimpleForm,
  TextInput,
  SelectInput,
  maxLength,
  required,
} from "react-admin";

import { CachedProvincesInput } from "../common/CachedProvincesInput/CachedProvincesInput";

const ClientTitle = ({ record }) => {
  return <span>Cliente {record ? `"${record.name}"` : ""}</span>;
};

const statusChoices = [
  { id: "PENDIENTE", name: "PENDIENTE" },
  // { id: "EMAIL_CONFIRMADO", name: "Email Confirmado" },
  { id: "APROBADO", name: "APROBADO" },
  // { id: "RECHAZADO", name: "Rechazado" },
];

export const ClientEdit = (props) => (
  <Edit
    title={<ClientTitle />}
    {...props}
    transform={(data) => {
      const ensureString = (value) =>
        value === null || value === undefined ? "" : value;

      return {
        ...data,
        // Asegurar que los strings vacíos se envíen como '' y no como null
        cuit: ensureString(data.cuit),
        name: ensureString(data.name),
        city: ensureString(data.city),
        address: ensureString(data.address),
        phone: ensureString(data.phone),
        transport: ensureString(data.transport),
        // Manejar la relación con la provincia
        province: data.provinceId ? data.provinceId : null,
      };
    }}
  >
    <SimpleForm redirect="list">
      <div
        style={{
          display: "flex",
          gap: "10px",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <TextInput source="id" disabled style={{ width: "100px" }} />
        <TextInput
          source="email"
          validate={[required(), maxLength(255)]}
          label="Correo Electrónico"
          disabled
        />
        <SelectInput
          source="status"
          label="Estado"
          choices={statusChoices}
          validate={[required()]}
        />
      </div>
      <div
        style={{
          display: "flex",
          gap: "10px",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <TextInput source="cuit" validate={[maxLength(14)]} label="CUIT" />
        <TextInput source="name" validate={[maxLength(100)]} label="Nombre" />
        <TextInput source="phone" validate={[maxLength(50)]} label="Teléfono" />
      </div>{" "}
      <div
        style={{
          display: "flex",
          gap: "10px",
          width: "100%",
          justifyContent: "space-between",
        }}
      >
        <CachedProvincesInput source="provinceId" label="Provincia" />
        <TextInput source="city" validate={[maxLength(100)]} label="Ciudad" />
        <TextInput
          source="address"
          validate={[maxLength(100)]}
          label="Dirección"
        />
      </div>
      <TextInput
        source="transport"
        validate={[maxLength(100)]}
        label="Transporte"
      />
    </SimpleForm>
  </Edit>
);
